// One USD owner. Amounts: >=1M two-decimal M; >=1K whole K; below 1K whole dollars.
// Unit prices always retain two decimals, regardless of magnitude. Null is never zero.
export function formatCurrency(value, mode = 'amount') {
  if (value == null || !Number.isFinite(Number(value))) return 'Not available';
  const n = Number(value), sign = n < 0 ? '-' : '', amount = Math.abs(n);
  if (mode === 'unit-price') return `${sign}$${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  if (mode === 'whole') return `${sign}$${amount.toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
  if (amount >= 1000000) return `${sign}$${(amount / 1000000).toFixed(2)}M`;
  if (amount >= 1000) return `${sign}$${(amount / 1000).toFixed(0)}K`;
  return `${sign}$${amount.toFixed(0)}`;
}
export const formatExactCurrency = value => value == null ? 'Not available' : `${Number(value) < 0 ? '-' : ''}$${String(value).replace(/^-/, '')} USD`;
export const formatNumber = (value, digits = 0) => value == null ? 'Not available' : Number(value).toLocaleString('en-US', { maximumFractionDigits: digits });

export const formatUnitPrice = value => formatCurrency(value, 'unit-price');
export const formatWholeDollars = value => formatCurrency(value, 'whole');
